import * as React from "react";
import clsx from "clsx";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";

const isFunctionEmpty = (func) => {
    const funcStr = func.toString().replace(/\s/g, '');
    return funcStr === '()=>' || funcStr === '()=>{}' || funcStr === 'function(){}';
};

export const MegamenuLink = ({
                                 parentLinks,
    children,
    hasSubLinks = false,
    subItem,
    onLinkClick = (subItem) => {},
    settings,
    megamenuSM
}) => {
    let isTitle = false;
    const titleText = useNavigationParse(subItem.title);
    const spanClass = isTitle ? "megamenu__title" : "";
    // const hoveredClass = ((activeLink.handle === subItem.handle) && subItem.level === 1) ? 'megamenu__link--active': '';
    // console.log('hoveredLink', megamenuSM.hoveredLink)

    const active = megamenuSM.menuState?.firstMenuHandle === megamenuSM.hoveredLink?.parent_handle;
    // console.log('handles', megamenuSM.menuState.firstMenuHandle, megamenuSM.hoveredLink?.parent_handle, subItem.handle, subItem?.level, active)

    return (
       <>
            {!isTitle &&
                <li className={'megamenu__link-container--inner'}>
                    <a
                        href={subItem.url}
                        className={clsx(`megamenu__link ${settings.section.link_style} ${spanClass}`, {
                            'active': (active),
                            'non-active': megamenuSM.hoveredLink && megamenuSM.hoveredLink?.handle !== subItem?.handle && subItem?.level <= 2
                        })}
                        {...(subItem.level <= 2 && { 'data-link-id': subItem.handle })}
                    >
                        {titleText.text} {titleText.icon && <i className={`icon ${titleText.icon}`}></i> }
                    </a>
                </li>}
            {isTitle &&
                <li>
                    <a href="#">
                        <span className={`${settings.section.title_style} ${spanClass}`}>{titleText.text} {titleText.icon &&
                            <i className={`icon ${titleText.icon}`}></i> }
                        </span>
                    </a>
                </li>
            }
            {!isTitle && !isFunctionEmpty(onLinkClick) && hasSubLinks && <i className={'icon-arrow-right lg:hidden'}></i>}
            {children}
        </>
    );
};

